import { render } from "./SoloImage.vue?vue&type=template&id=7b86466f"
import script from "./SoloImage.vue?vue&type=script&lang=js"
export * from "./SoloImage.vue?vue&type=script&lang=js"

import "./SoloImage.vue?vue&type=style&index=0&id=7b86466f&lang=css"

import exportComponent from "G:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__